import { get } from "../../utils/BaseService";

export async function getAllSACDetails(dispatch: any,input:{search:string|null}) {
   if(!input?.search){
         return await get(dispatch, '/sacDetails/getAllSACDetails', null)
   }else{
      return await get(dispatch, '/sacDetails/getAllSACDetails', input)
   }
   
}